import styles from './testimonial-card.module.scss';
import IImage from '../../../models/viewModels/base/IImage';
import ImageComponent from '../../atoms/image-component/image-component';

export type TestimonialProps = {
  orientation: string;
  aspectRatio: string;
  image: IImage;
  name: string;
  studentCountry: string;
  quote: string;
  jobTitleAndCompany: string;
  pathwayCourse?: string;
  universityDegree: string;
};
const defaultquote =
  'Lorem ipsum dolor sit amet. Vel veniam voluptas est atque reiciendis vel ullam quibusdam est magnam eligendi et rerum voluptas rem facere asperiores et dolorem neque!';


const TestimonialCardImage = ({ image }: { image: IImage }) => {
  const src =
    image?.secureUrl ||
    'https://media.intostudy.com/image/upload/v1681806049/Marketing_Team/Global/Images/PP-news-thumbnail-placeholder.png';
  const altText = image?.alt || 'Image unavailable';
  const width = image?.width ? +image.width : 320;
  const height = image?.height ? +image.height : 200;

  return (
    <div className={styles['media']}>
      <ImageComponent src={src} altText={altText} width={width} height={height} />
    </div>
  );
};

const TestimonialCardText = ({
  name,
  image,
  studentCountry,
  jobTitleAndCompany,
  quote,
  universityDegree,
  pathwayCourse,
}: {
  name: string;
  image: IImage;
  studentCountry: string;
  jobTitleAndCompany: string;
  quote: string;
  universityDegree: string;
  pathwayCourse?: string;
}) => {
  return (
    <div
      className={`${styles[`text-container`]} ${
        image == null && styles[`text-container-without-image`]
      }`}
    >
      <div className={styles['student-name']}>
        <h3>{name ? name : 'TBD'}</h3>
        <span className={`${styles['mid-gray-copy-text']}`}>
          &nbsp;|&nbsp;{studentCountry ? studentCountry : 'TBD'}
        </span>
      </div>

      <p className={styles['mid-gray-copy-text']}>{jobTitleAndCompany}</p>
      <p>{quote ? quote : defaultquote}</p>
      {pathwayCourse && (
        <p className={styles['mid-gray-copy-text']}>{pathwayCourse}</p>
      )}
      <p className={`${styles['mid-gray-copy-text']} mb-2`}>{universityDegree}</p>
      
    </div>
  );
};

export default function TestimonialCard({
  orientation,
  aspectRatio,
  image,
  name,
  studentCountry,
  quote,
  jobTitleAndCompany,
  pathwayCourse,
  universityDegree,
}: TestimonialProps) {
  return (
    <div className={styles[`testimonial-card`]}>
      <div
        className={`${styles[`testimonial-card_block`]}
          ${orientation != 'horizontal' ? styles[`vertical-card`] : styles[`horizontal-card`]} 
          ${aspectRatio == 'keep ratio' ? styles[`keep-ratio`] : styles[`fill-height`]}`}
      >
        <TestimonialCardImage image={image} />
        <TestimonialCardText
          name={name}
          image={image}
          studentCountry={studentCountry}
          quote={quote}
          jobTitleAndCompany={jobTitleAndCompany}
          pathwayCourse={pathwayCourse}
          universityDegree={universityDegree}
        />
      </div>
    </div>
  );
}
